// import React from "react";
// import { useParams, Link } from "react-router-dom";
// import jobData from "./jobs-data.json";
// import { Helmet } from "react-helmet";
// import {
//   FaMapMarkerAlt,
//   FaBuilding,
//   FaCalendarAlt,
//   FaCheckCircle,
// } from "react-icons/fa";

// const JobDetail = () => {
//   const { id } = useParams();
//   const job = jobData.find((job) => job.id.toString() === id);

//   if (!job) {
//     return <div className="text-center py-10 text-lg">Job not found</div>;
//   }

//   const formatRequirements = (requirements) => {
//     if (typeof requirements === "object") {
//       return Object.entries(requirements).map(([key, value], index) => (
//         <div key={index} className="mb-4">
//           <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-1">
//             {key}
//           </h3>
//           <ul className="list-disc list-inside text-gray-700">
//             {Array.isArray(value)
//               ? value.map((item, i) => (
//                   <li key={i} className="text-base md:text-md leading-relaxed">
//                     {item}
//                   </li>
//                 ))
//               : value}
//           </ul>
//         </div>
//       ));
//     }
//     return <p className="text-gray-700">{requirements}</p>;
//   };

// const truncateTitle = (title, maxLength = 60) =>
//   title.length > maxLength
//     ? title.substring(0, title.lastIndexOf(" ", maxLength)) + "..."
//     : title;

// const truncateText = (text, maxLength = 150) =>
//   text.length > maxLength
//     ? text.substring(0, maxLength).trim() + "..."
//     : text;

//   return (
//     <>
// <Helmet>
//   {/* Title */}
//   <title>{truncateTitle(`${job.title} | Careers at Navisha`)}</title>

//   {/* Meta Description */}
//   <meta name="description" content={truncateText(job.description, 150)} />

//   {/* Canonical URL */}
//   <link rel="canonical" href={`https://www.navishaa.com/job/${job.id}`} />

//   {/* Open Graph (OG) tags */}
//   <meta property="og:locale" content="en_US" />
//   <meta property="og:type" content="website" />
//   <meta
//     property="og:title"
//     content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//   />
//   <meta
//     property="og:description"
//     content={truncateText(job.description, 150)}
//   />
//   <meta
//     property="og:url"
//     content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//   />
//   <meta property="og:site_name" content="Navishaa" />
//   <meta
//     property="og:image"
//     content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
//   />
//   <meta property="og:image:width" content="1200" />
//   <meta property="og:image:height" content="630" />

//   {/* Twitter tags */}
//   <meta name="twitter:card" content="summary_large_image" />
//   <meta name="twitter:site" content="@Navishaa" />
//   <meta
//     name="twitter:title"
//     content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//   />
//   <meta
//     name="twitter:description"
//     content={truncateText(job.description, 150)}
//   />
//   <meta
//     name="twitter:image"
//     content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
//   />
//   <meta name="twitter:label1" content="Written by" />
//   <meta name="twitter:data1" content="Navishaa" />
//   <meta name="twitter:label2" content="Est. reading time" />
//   <meta name="twitter:data2" content="3 minutes" />

//   {/* LinkedIn tags */}
//   <meta
//     property="og:url"
//     content="https://www.linkedin.com/company/navishaa/"
//   />
//   <meta
//     property="og:title"
//     content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//   />
//   <meta
//     property="og:description"
//     content={truncateText(job.description, 150)}
//   />
//   <meta
//     property="og:image"
//     content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
//   />

//   {/* Structured Data - Schema.org */}
//   <script type="application/ld+json">
//     {`
//           {
//             "@context": "https://schema.org",
//             "@type": "Article",
//             "headline": "https://www.navishaa.com/career/${job.id}",
//             "author": {
//               "@type": "Person",
//               "name": "Navishaa"
//             },
//             "datePublished": "2024-09-24",
//             "dateModified": "2024-09-24",
//             "image": {
//               "@type": "ImageObject",
//               "url": "https://www.navishaa.com/images/api-integration-banner.png",
//               "width": 1200,
//               "height": 630
//             },
//             "publisher": {
//               "@type": "Organization",
//               "name": "Navishaa",
//               "logo": {
//                 "@type": "ImageObject",
//                 "url": "https://www.navishaa.com/images/logo.png",
//                 "width": 1854,
//                 "height": 503
//               }
//             },
//             "mainEntityOfPage": "https://www.navishaa.com/job/${job.id}",
//             "url": "https://www.navishaa.com/job/${job.id}",
//             "description":{truncateText(job.description, 150)}
//           }
//         `}
//   </script>
// </Helmet>

//       <div className="job-detail bg-gradient-to-l from-pink-50 to-purple-50 min-h-screen pb-20">
//         {/* Hero Section */}
//         <section
//           className="relative py-16 md:py-24 lg:py-28 mb-12 overflow-hidden"
//           style={{
//             backgroundImage: `url("https://res.cloudinary.com/dbitupkaa/image/upload/f_auto,q_auto/v1737458572/HomePage_d3y2gy.png")`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//         >
//           <div className="max-w-6xl mx-auto text-center md:text-left px-4 md:px-8 lg:px-10 relative z-0">
//             <h1 className="text-4xl md:text-5xl text-black font-bold mb-4 drop-shadow-lg">
//               {job.title}
//             </h1>
//             <p className="text-lg md:text-xl text-gray-900">
//               Explore this opportunity and see if it's a perfect match for your
//               career aspirations.
//             </p>
//           </div>
//         </section>

//         {/* Job Details Section */}
//         <section className="max-w-4xl mx-auto bg-white shadow-lg rounded-2xl p-6 md:p-10 lg:p-12">
//           {/* Description */}
//           <div className="mb-10">
//             <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 underline decoration-purple-500">
//               Description
//             </h2>
//             <p className="text-gray-700 leading-relaxed text-base md:text-lg">
//               {job.description}
//             </p>
//           </div>

//           {/* Key Responsibilities */}
//           <div className="mb-10">
//             <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 underline decoration-purple-500">
//               Key Responsibilities
//             </h2>
//             <div className="space-y-6">
//               {Object.entries(job.key_responsibilities).map(
//                 ([sectionTitle, tasks], index) => (
//                   <div key={index}>
//                     <h3 className="text-xl font-semibold text-gray-700 mb-2">
//                       {sectionTitle}
//                     </h3>
//                     <ul className="list-disc list-inside space-y-1 text-gray-700">
//                       {tasks.map((task, i) => (
//                         <li key={i}>{task}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 )
//               )}
//             </div>
//           </div>

//           {/* Requirements */}
//           <div className="mb-10">
//             <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 underline decoration-purple-500">
//               Requirements
//             </h2>
//             {formatRequirements(job.requirements)}
//           </div>

//           {/* Growth Path (Optional Section) */}
//           {job.growth_path && (
//             <div className="mb-10">
//               <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 underline decoration-purple-500">
//                 Growth Path
//               </h2>
//               <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2">
//                 {job.growth_path.map((point, index) => (
//                   <li key={index}>{point}</li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {/* Benefits */}
//           {job.benefits && (
//             <div className="mb-10">
//               <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 underline decoration-purple-500">
//                 Benefits
//               </h2>
//               <ul className="space-y-2">
//                 {job.benefits.map((benefit, index) => (
//                   <li
//                     key={index}
//                     className="flex items-start text-gray-700 leading-relaxed"
//                   >
//                     <FaCheckCircle className="text-green-500 mt-1 mr-2" />
//                     <span>{benefit}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}

//           {/* Application Details */}
//           {job.application_details && (
//             <div className="mb-10">
//               <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 underline decoration-purple-500">
//                 Application Details
//               </h2>
//               <p className="text-gray-700 leading-relaxed text-base md:text-lg">
//                 {job.application_details}
//               </p>
//             </div>
//           )}

//           {/* About Company */}
//           {job.about_company && (
//             <div>
//               <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 underline decoration-purple-500">
//                 About the Company
//               </h2>

//               {/* Handle both string or nested objects */}
//               {typeof job.about_company === "object" ? (
//                 Object.entries(job.about_company).map(([company, details]) => (
//                   <div key={company} className="mb-6">
//                     <h3 className="text-xl font-semibold text-gray-700 mb-2">
//                       {company}
//                     </h3>
//                     <p className="text-gray-700 leading-relaxed">{details}</p>
//                   </div>
//                 ))
//               ) : (
//                 <p className="text-gray-700 leading-relaxed">
//                   {job.about_company}
//                 </p>
//               )}
//             </div>
//           )}

//           {/* Job Metadata */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10 mb-8">
//             <div className="flex items-center text-gray-700">
//               <FaMapMarkerAlt className="mr-2 text-xl text-purple-600" />
//               <span className="font-semibold mr-1">Location:</span>
//               <span>{job.location}</span>
//             </div>
//             <div className="flex items-center text-gray-700">
//               <FaBuilding className="mr-2 text-xl text-purple-600" />
//               <span className="font-semibold mr-1">Department:</span>
//               <span>{job.department}</span>
//             </div>
//             <div className="flex items-center text-gray-700">
//               <FaCalendarAlt className="mr-2 text-xl text-purple-600" />
//               <span className="font-semibold mr-1">Date Posted:</span>
//               <span>{job.date}</span>
//             </div>
//           </div>

//           {/* Apply Now Button */}
//           <div className="text-center mt-10">
//             <Link
//               to={`/apply/${job.id}`}
//               className="inline-block px-10 py-3 text-lg bg-gradient-to-l from-[#9629E7] to-[#0860C7] text-white font-medium rounded-full hover:from-[#0860C7] hover:to-[#9629E7] shadow-lg transition-transform transform hover:scale-105"
//             >
//               Apply Now
//             </Link>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };

// export default JobDetail;

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { findJobById, loadJobs } from "./loadJobs";
import { Helmet } from "react-helmet";
import { FaMapMarkerAlt, FaBuilding, FaCalendarAlt } from "react-icons/fa";

const JobDetail = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [jobLoading, setJobLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    loadJobs()
      .then((jobs) => {
        if (!isMounted) return;
        setJob(findJobById(jobs, id) || null);
      })
      .catch((err) => {
        console.error("Error loading job:", err);
        if (isMounted) setLoadError(err.message);
      })
      .finally(() => {
        if (isMounted) setJobLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [id]);

  if (jobLoading) {
    return (
      <div className="text-center py-10 text-lg font-semibold">Loading...</div>
    );
  }

  if (loadError) {
    return (
      <div className="text-center py-10 text-lg font-semibold">
        Error loading job: {loadError}
      </div>
    );
  }

  if (!job) {
    return (
      <div className="text-center py-10 text-lg font-semibold">
        Job not found
      </div>
    );
  }

  const truncateTitle = (title, maxLength = 60) =>
    title.length > maxLength
      ? title.substring(0, title.lastIndexOf(" ", maxLength)) + "..."
      : title;

  const truncateText = (text, maxLength = 150) =>
    text?.length > maxLength
      ? text.substring(0, maxLength).trim() + "..."
      : text;

  const renderValue = (value) => {
    if (!value) return null;

    if (typeof value === "string" || typeof value === "number") {
      return <p className="text-gray-700 leading-relaxed mb-1">{value}</p>;
    }

    if (Array.isArray(value)) {
      return (
        <div className="space-y-1">
          {value.map((item, i) => (
            <div key={i} className="pl-2 border-l-2 border-purple-300">
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                {item}
              </p>
            </div>
          ))}
        </div>
      );
    }

    if (typeof value === "object") {
      return (
        <div className="space-y-3">
          {Object.entries(value).map(([subKey, subVal], i) => (
            <div key={i} className="ml-1">
              <h4 className="font-semibold text-gray-800 mt-1 mb-1 text-base">
                {subKey}
              </h4>
              {renderValue(subVal)}
            </div>
          ))}
        </div>
      );
    }

    return null;
  };

  const formatTitle = (key) => {
    const labels = {
      about_company: "About Navishaa",
      key_responsibilities: "Key Responsibilities",
      employment_type: "Employment Type",
      date: "Date",
    };

    if (labels[key]) return labels[key];

    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  const getFieldValue = (key) => {
    if (key === "department") {
      return (
        job.department ||
        (job.category && job.category !== "Other" ? job.category : null)
      );
    }
    return job[key];
  };

  const jobDisplayOrder = [
    "description",
    "key_responsibilities",
    "employment_type",
    "experience",
    "department",
    "location",
    "requirements",
    "about_company",
  ];

  const departmentLabel =
    job.department ||
    (job.category && job.category !== "Other" ? job.category : null);

  const hiddenKeys = [
    "id",
    "title",
    "image",
    "slug",
    "company",
    "application_details",
    "category",
    "why_join_getmax",
    "about_navishaa",
    "benefits",
    "growth_path",
    "key_objectives",
    "performance_kpis",
    "stakeholder_collaboration",
    "reporting_to",
    "career_progression",
    "performance_indicators",
  ];

  return (
    <>
      <Helmet>
        {/* Title */}
        <title>{truncateTitle(`${job.title} | Careers at Navisha`)}</title>

        {/* Meta Description */}
        <meta name="description" content={truncateText(job.description, 150)} />

        {/* Canonical URL */}
        <link rel="canonical" href={`https://www.navishaa.com/job/${job.id}`} />

        {/* Open Graph (OG) tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={truncateTitle(`${job.title} | Careers at Navishaa`)}
        />
        <meta
          property="og:description"
          content={truncateText(job.description, 150)}
        />
        <meta
          property="og:url"
          content={truncateTitle(`${job.title} | Careers at Navishaa`)}
        />
        <meta property="og:site_name" content="Navishaa" />
        <meta
          property="og:image"
          content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Twitter tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Navishaa" />
        <meta
          name="twitter:title"
          content={truncateTitle(`${job.title} | Careers at Navishaa`)}
        />
        <meta
          name="twitter:description"
          content={truncateText(job.description, 150)}
        />
        <meta
          name="twitter:image"
          content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
        />
        <meta name="twitter:label1" content="Written by" />
        <meta name="twitter:data1" content="Navishaa" />
        <meta name="twitter:label2" content="Est. reading time" />
        <meta name="twitter:data2" content="3 minutes" />

        {/* LinkedIn tags */}
        <meta
          property="og:url"
          content="https://www.linkedin.com/company/navishaa/"
        />
        <meta
          property="og:title"
          content={truncateTitle(`${job.title} | Careers at Navishaa`)}
        />
        <meta
          property="og:description"
          content={truncateText(job.description, 150)}
        />
        <meta
          property="og:image"
          content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
        />

        {/* Structured Data - Schema.org */}
        <script type="application/ld+json">
          {`
                {
                  "@context": "https://schema.org",
                  "@type": "Article",
                  "headline": "https://www.navishaa.com/career/${job.id}",
                  "author": {
                    "@type": "Person",
                    "name": "Navishaa"
                  },
                  "datePublished": "2024-09-24",
                  "dateModified": "2024-09-24",
                  "image": {
                    "@type": "ImageObject",
                    "url": "https://www.navishaa.com/images/api-integration-banner.png", 
                    "width": 1200,
                    "height": 630
                  },
                  "publisher": {
                    "@type": "Organization",
                    "name": "Navishaa",
                    "logo": {
                      "@type": "ImageObject",
                      "url": "https://www.navishaa.com/images/logo.png",
                      "width": 1854,
                      "height": 503
                    }
                  },
                  "mainEntityOfPage": "https://www.navishaa.com/job/${job.id}",
                  "url": "https://www.navishaa.com/job/${job.id}",
                  "description":{truncateText(job.description, 150)}
                }
              `}
        </script>
      </Helmet>

      <div className="bg-gradient-to-l from-pink-50 to-purple-50 min-h-screen pb-12">
        {/* Hero Section */}
        <section
          className="relative pt-20 md:py-32 mb-8"
          style={{
            backgroundImage:
              'url("https://res.cloudinary.com/dbitupkaa/image/upload/f_auto,q_auto/v1737458572/HomePage_d3y2gy.png")',
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="max-w-5xl mx-auto text-center px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-2">
              {job.title}
            </h1>
            <p className="text-base sm:text-lg text-gray-700">
              Explore this opportunity and see if it’s a perfect match for your
              career aspirations.
            </p>
          </div>
        </section>

        {/* Job Details */}
        <section className="max-w-4xl mx-auto bg-white rounded-xl shadow-md p-5 sm:p-8 space-y-6">
          {jobDisplayOrder.map((key) => {
            const value = getFieldValue(key);
            if (!value) return null;

            return (
              <div key={key} className="border-b border-gray-100 pb-4">
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-2">
                  {formatTitle(key)}
                </h2>
                {renderValue(value)}
              </div>
            );
          })}

          {/* Job Meta Info */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4 pt-4 border-t border-gray-200">
            {job.location && (
              <div className="flex items-center text-gray-700 text-sm sm:text-base">
                <FaMapMarkerAlt className="mr-2 text-[#0860C7]" />
                <span>
                  <strong>Location:</strong> {job.location}
                </span>
              </div>
            )}
            {departmentLabel && (
              <div className="flex items-center text-gray-700 text-sm sm:text-base">
                <FaBuilding className="mr-2 text-[#0860C7]" />
                <span>
                  <strong>Department:</strong> {departmentLabel}
                </span>
              </div>
            )}
            {job.date && (
              <div className="flex items-center text-gray-700 text-sm sm:text-base">
                <FaCalendarAlt className="mr-2 text-[#0860C7]" />
                <span>
                  <strong>Date Posted:</strong> {job.date}
                </span>
              </div>
            )}
          </div>

          {/* Apply Button */}
          <div className="text-center mt-6">
            <Link
              to={`/apply/${job.id}`}
              className="inline-block px-8 py-2 sm:px-10 sm:py-3 text-base sm:text-lg bg-[#0860C7] text-white font-medium rounded-full shadow-md hover:scale-105 transition-transform"
            >
              Apply Now
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default JobDetail;
